/**
 * Runtime environment variable accessor.
 *
 * Priority order:
 *  1. window._env_  — injected at container/IIS deploy time by docker-entrypoint.sh
 *                     or scripts/deploy-env.ps1. Placeholder values (__KEY__)
 *                     are treated as unset.
 *  2. process.env   — values baked in at build time by CRA (used for local dev
 *                     via .env.local / .env.test).
 *  3. defaultValue  — hard-coded fallback.
 */
export function getEnv(key: string, defaultValue: string = ''): string {
  if (typeof window !== 'undefined') {
    const runtime = (window as any)._env_?.[key];
    if (runtime && !runtime.startsWith('__') && !runtime.endsWith('__')) {
      return runtime;
    }
  }
  return (process.env[key] as string | undefined) || defaultValue;
}
